const CF_DOMAIN = process.env.NEXT_PUBLIC_CF_IMAGE_DOMAIN;

export default function imageLoader({
  src,
  width,
  quality,
}: {
  src: string;
  width: number;
  quality?: number;
}): string {
  if (CF_DOMAIN && src.startsWith("http")) {
    return `${CF_DOMAIN}/cdn-cgi/image/width=${width},quality=${quality || 75},format=auto/${src}`;
  }

  return src;
}
